export const SET_ACTIVE_LAYER = "SET_ACTIVE_LAYER";
export const SET_INACTIVE_LAYER = "SET_INACTIVE_LAYER";
export const SET_BASE_MAP = "SET_BASE_MAP";
export const SET_LAYER_NOW = "SET_LAYER_NOW";
export const SET_DIRECTION_TOGGLE = "SET_DIRECTION_TOGGLE";
export const SET_MARKERS = "SET_MARKERS";
export const GET_LAYERS = "GET_LAYERS";
export const SET_CITRA = "SET_CITRA";
export const SET_SIDEBAR_TOGGLE = "SET_SIDEBAR_TOGGLE";
export const SET_BIDANG_LAYER = "SET_BIDANG_LAYER";
export const SET_LEGEND_NOW = "SET_LEGEND_NOW";
export const SET_LAST_PARENT = "SET_LAST_PARENT";
export const SET_ALL_BIDANG = "SET_ALL_BIDANG";
export const SET_URL_FILTER = "SET_URL_FILTER";
export const SET_SPESIFICT_HIERARKI = "SET_SPESIFICT_HIERARKI";
export const SET_ACTIVE_LIST = "SET_ACTIVE_LIST";
export const SET_LAYERS_FROM_MAPS = "SET_LAYERS_FROM_MAPS";
export const SET_UPDATE_LAYERS_FROM_MAPS = "SET_UPDATE_LAYERS_FROM_MAPS";
export const SET_HOLLOW_MAPS = "SET_HOLLOW_MAPS";
export const SET_BIDANG_RESULT = "SET_BIDANG_RESULT";
export const SET_GEOJSON_EDITING_DATA = "SET_GEOJSON_EDITING_DATA";
export const SET_STYLES_VALUES = "SET_STYLES_VALUES";
export const FILTER_LEGEND_MAP = "FILTER_LEGEND_MAP";
export const LOADING_RENDER_MAP = "LOADING_RENDER_MAP";
export const SET_LEGENDA_ARR = "SET_LEGENDA_ARR";
export const RESET_BIDANG_HIERARKI = "RESET_BIDANG_HIERARKI";
export const SET_SIG_TIPE_DATA = "SET_SIG_TIPE_DATA";
export const SET_SHOW_PETA_JALAN = "SET_SHOW_PETA_JALAN";
export const SET_URL_FILTER_BY_FIELD = "SET_URL_FILTER_BY_FIELD";
export const SET_TRIGGER_REQUEST = "SET_TRIGGER_REQUEST";
